import { useMutation } from '@tanstack/react-query'
import { updateChannel } from 'services/ChannelService'

export const useUpdateChannel = () => {
  return useMutation({ mutationFn: updateChannel })
}
